import EnumService from '../services/EnumService'
import store from '../store'

export default {
    async setupEnums () {
        const vehicleDeviceTypes = await EnumService.getVehicleDeviceTypes()
        store.commit('setDeviceTypes', vehicleDeviceTypes.data.items)

        const vehicleTypes = await EnumService.getVehicleTypes()
        store.commit('setVehicleTypes', vehicleTypes.data.items)

        const fuelTypes = await EnumService.getFuelTypes()
        store.commit('setFuelTypes', fuelTypes.data.items)

        const roles = await EnumService.getRoles()
        store.commit('setRoles', roles.data.items)

        const eventTypes = await EnumService.getEventTypes()
        store.commit('setEventTypes', eventTypes.data.items)

        const vehicleStatuses = await EnumService.getVehicleStatuesTypes()
        store.commit('setVehicleStatuesTypes', vehicleStatuses.data.items)

        const snapshotTypes = await EnumService.getSnapshotTypes()
        store.commit('setSnapshotTypes', snapshotTypes.data.items)

        const deviceIntegrations = await EnumService.getDeviceIntegrations()
        store.commit('setDeviceIntegrations', deviceIntegrations.data.items)

        const dataToCapture = await EnumService.getDataToCapture()
        store.commit('setDataToCapture', dataToCapture.data.items)

        const eventAlertLevelType = await EnumService.getEventAlertLevelType()
        store.commit('setEventAlertLevelType', eventAlertLevelType.data.items)

        const requestStatus = await EnumService.getRequestStatus()
        store.commit('setRequestStatus', requestStatus.data.items)

        const requestType = await EnumService.getRequestType()
        store.commit('setRequestType', requestType.data.items)
    },
    searchById (enums, id) {
        let value = enums.find((enumObject) => {
            return enumObject.id === id
        })

        return null == value ? null : value
    }
}
